<div id="handoversScaffoldStatusChart"></div>
